import { gql } from '@apollo/client';
import { LocaleCode, LOCALE_BY_CODE } from '../../../../../utils/Locale';
import { queryWithFallbackKey } from '../../../common/tools/queryWithFallbackKey';

export const GET_PRODUCT_APPLICATIONS_QUERY = queryWithFallbackKey(
    gql`
        query getProductApplicationSegmentListing($defaultLanguage: String!) {
            getObjectFolder(
                fullpath: "/Resource Library/Categorization/Product Applications"
                defaultLanguage: $defaultLanguage
            ) {
                children {
                    ... on object_ProductApplicationSegment {
                        id
                        key
                        name
                        hubspotYageoContactUs_enabled: hubspotYageoContactUs_applicationSegment_enabled
                        hubspotYageoContactUs_fieldValue: hubspotYageoContactUs_applicationSegment_fieldValue
                        applications {
                            id
                            key
                            name
                        }
                    }
                }
            }
        }
    `,
    'GET_PRODUCT_APPLICATIONS_QUERY'
);

export function getProductApplicationsQueryVariables(localeCode: LocaleCode) {
    return {
        defaultLanguage: LOCALE_BY_CODE[localeCode].pimcoreCode,
    };
}
